import * as React from 'react';
export const paytoSvg = React.forwardRef(function paytoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#231F20',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.286 23.385c.75.301 1.554.45 2.362.44a6.05 6.05 0 0 0 6.104-6.104 6.11 6.11 0 0 0-.561-2.556h-2.34c.5.76.772 1.646.784 2.556a3.99 3.99 0 1 1-7.973 0c0-2.133 1.764-4.039 3.898-4.039h6.967v1.936l3.547-2.95-3.54-2.946v1.896h-6.886a6.103 6.103 0 0 0-2.362 11.767Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.602 21.429a5.201 5.201 0 0 1-1.432.276l.002-.003a1.726 1.726 0 0 1-1.713-1.715v-6.305h3.602a7.793 7.793 0 0 1 2.05-2.064H8.459V9H6.388v2.618H4v2.064h2.385v6.308a3.815 3.815 0 0 0 3.785 3.837 4.164 4.164 0 0 0 1.432-.3v-2.098Z',
      fill: '#fff',
    }),
  );
});
paytoSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var payto = {
  category: 'brand',
  colorable: false,
  name: 'payto',
  svg: paytoSvg,
};
